import "./bootstrap";
import { createApp } from "vue/dist/vue.esm-bundler";
import { createPinia } from "pinia";
import { useGlobalStore } from "@stores/global";
import { useShopifyStore } from "@stores/shopify";

// Directives
import clickOutside from "./directives/clickOutside";

import router from "./router";

const pinia = createPinia();
const app = createApp({}).use(router).use(pinia);
const global = useGlobalStore();
const shopify = useShopifyStore();

global.setup();
shopify.setup();

app.directive("click-outside", clickOutside);
app.mount("#ghost");
